import Button from '@insided/control/uikit/Button'
// eslint-disable-next-line import/no-internal-modules
import ColorPicker from '@insided/deprecated-preact-components/theme-configuration/ColorPicker'
import { Component } from 'preact'
import { ColorCheckbox } from './ColorCheckbox'
import COLORS from './config.json'
// eslint-disable-next-line import/no-internal-modules
import { StylingConfigType } from '@insided/deprecated-preact-components/theme-configuration/configurator'

interface Props {
  updatedStyling: StylingConfigType
  defaultStyling: StylingConfigType
  onUpdate: (updatedStyling: StylingConfigType) => void
}

interface State {
  enabledColorSelector: null | string
}

export * from './getCssVar'

export class Colors extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      enabledColorSelector: null
    }

    this.updateColors = this.updateColors.bind(this)
    this.resetColors = this.resetColors.bind(this)
  }

  updateColors(key: string, color: string | null) {
    this.props.onUpdate({ ...this.props.updatedStyling, ...{ [key]: color } })
  }

  resetColors() {
    this.props.onUpdate(this.props.defaultStyling)
  }

  render() {
    const { updatedStyling } = this.props
    const { enabledColorSelector } = this.state
    return (
      <div className='box__pad'>
        <ul className='theme-configuration_colors-list'>
          {COLORS.map((color) => (
            <li
              key={color.key}
              className={`theme-configuration_colors-list-item ${color.title
                .toLocaleLowerCase()
                .split(' ')
                .join('-')}`}
            >
              <strong>{color.title}</strong>
              <p>{color.description}</p>
              <ColorPicker
                color={
                  !!color.checkbox && updatedStyling[color.key] === null
                    ? updatedStyling[color.checkbox.key]
                    : updatedStyling[color.key]
                }
                disabled={!!color.checkbox && updatedStyling[color.key] === null}
                colorKey={color.key}
                disableColorSelector={() => this.setState({ enabledColorSelector: null })}
                setColorSelector={() => this.setState({ enabledColorSelector: color.key })}
                updateColor={(newColor: string) => this.updateColors(color.key, newColor)}
                isColorSelectorEnabled={enabledColorSelector === color.key}
              />
              {color.checkbox && (
                <ColorCheckbox
                  colorKey={color.key}
                  colorCheckbox={color.checkbox}
                  updatedStyling={updatedStyling}
                  onChange={(newValue) => {
                    this.updateColors(color.key, newValue)
                  }}
                />
              )}
            </li>
          ))}
          <Button
            title='Reset to defaults'
            variant='warning'
            size='medium'
            onClick={this.resetColors}
          />
        </ul>
      </div>
    )
  }
}

export default Colors
